import React from 'react';

import {StreamBankLink} from "../../StreamBankLink";

export const CreateProgramActivityFeedItemDescription = props => <p>
    {props.Event.Activity.User.name} created a new Program <StreamBankLink
    Context={props.Event.ContextNodeDetails.link}>{props.CustomEventData ? props.CustomEventData.title : ""}</StreamBankLink>.
</p>;



